import React from 'react';

import ActionsCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/ActionsCell';
import LinkActions from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/LinkActions';
import StatusCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/StatusCell';
import RevisionCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/RevisionCell';
import IntegrationCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/integration/IntegrationCell';
import ConsentCategoryCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/ConsentCategoryCell';
import ConsentModeCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/ConsentModeCell';
import PipelineVariablesCell from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/PipelineVariablesCell';
import { conditionalCellStyles } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/conditional-cell-styles';

export const columns = [
  {
    name: 'Integration Name',
    selector: row => row.integration.name,
    cell: row => <IntegrationCell integration={row.integration} />,
    conditionalCellStyles: conditionalCellStyles,
  },
  {
    name: 'Status',
    cell: row => <StatusCell {...row} />,
    conditionalCellStyles: conditionalCellStyles,
  },
  {
    name: 'Revision',
    cell: row => <RevisionCell {...row} />,
    conditionalCellStyles: conditionalCellStyles,
  },
  {
    name: 'Pipeline Variables',
    selector: row => <PipelineVariablesCell {...row} />,
    conditionalCellStyles: conditionalCellStyles,
  },
];

export const ActionColumn = {
  cell: row => <ActionsCell {...row} />,
  button: true,
  width: '77px',
};

export const LinkColumn = {
  cell: row => <LinkActions {...row} />,
  button: true,
  width: '93px',
};

export const ConsentModeColumn = {
  name: 'Consent Mode',
  selector: row => <ConsentModeCell {...row} />,
  conditionalCellStyles: conditionalCellStyles,
};

export const CategoryColumn = {
  name: 'Consent Category',
  selector: row => <ConsentCategoryCell {...row} />,
  conditionalCellStyles: conditionalCellStyles,
};
